import { Outlet } from "react-router";

import { AppNav } from "@/app/app-nav";

export const CarriersLayout = () => {
  return (
    <>
      <AppNav />
      <main className="flex flex-auto overflow-hidden">
        <Outlet />
      </main>
    </>
  );
};
